import ChangeForgotPasswordForm from "./change-forgot-password-form";


export default ChangeForgotPasswordForm;